module.exports = __webpack_public_path__ + "img/Presentation15.10d636d7.png";